import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import Link from '@Navigation/Link';
import Phone from '@Components/Phone';
import Img from '@UI/Img';
import phoneImg from './tel.svg';
import scheduleImg from './clock.svg';
import mailImg from './mail.svg';
import contractImg from './contract.svg';
import styles from './QualityDepartment.module.css';

import type { Schedule } from '@Types/Shedule';
import type { FC, HTMLAttributes } from 'react';

export interface QualityDepartmentProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  oferta?: string;
  schedule: Schedule[];
  title?: string;
}

const QualityDepartment: FC<QualityDepartmentProps> = (props) => {
  const { className, schedule, oferta, title, ...restProps } = props;
  const { t } = useTranslation();

  const pageTitle = title ? title : t('ui.quality-department');

  const icons = {
    phone: phoneImg,
    schedule: scheduleImg,
    mail: mailImg,
    contract: contractImg,
  };

  const handleClick = useCallback(() => {
    ModalWindows.open('StaticInfo', { slug: 'oferta', hash: '#oferta' });
  }, []);

  return (
    <div {...restProps} className={cn(styles.container, className)}>
      <div className={styles.head}>
        <div className={styles.mainTitle}>{pageTitle}</div>
        {oferta && (
          <div className={styles.oferta}>
            <div className={styles.ofertaLink} onClick={handleClick}>
              <Img src={icons.contract} className={styles.iconOferta} loading='eager' />
              {t('ui.oferta')}
            </div>
          </div>
        )}
      </div>

      <div className={styles.body}>
        {schedule.map((scheduleItem) => (
          <div className={styles.item} key={scheduleItem.type}>
            <Img src={icons[scheduleItem.type]} className={styles.icon} loading='eager' />
            <div className={styles.info}>
              <div className={styles.itemTitle}>{scheduleItem.name}</div>
              {scheduleItem.type === 'phone' &&
                scheduleItem.items.map((current) => {
                  return (
                    <Phone
                      key={current}
                      view='primary'
                      className={styles.itemValue}
                      phone={current}
                    />
                  );
                })}
              {scheduleItem.type === 'mail' &&
                scheduleItem.items.map((current) => {
                  return (
                    <Link
                      key={current}
                      view='primary'
                      className={styles.itemValue}
                      to={`mailto:${current}`}
                    >
                      <span itemProp='email'>{current}</span>
                    </Link>
                  );
                })}
              {scheduleItem.type === 'schedule' &&
                scheduleItem.items.map((current) => (
                  <div
                    key={current}
                    className={styles.itemValue}
                    dangerouslySetInnerHTML={{ __html: current }}
                  />
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(QualityDepartment);
